module.exports = __webpack_public_path__ + "static/assets/051f1b10192cffb9b512871deaaea2ae.svg";